const ACCOUNT_TYPE = {
  WX: "WX",
  QQ: "QQ"
}

const CHECK_ROLE_TYPE = {
  NO_CHECK: 0, //不验证帐户
  CHECK: 1, //要验证帐户
  CHECK_HAS_ROLE: 2, //只验证有角色
  SELECT_ROLE: 3 //必须选角色
}

const PRODUCT_STATUS = {
  ONLINE: 1,
  OFFLINE: 0,
  APPOINTMENT: 2,
  WHITELIST: 3
}

const BUSINESS_TYPE = {
  MOBILE_GAME: 1,
  MONTH: 2,
  PC_GAME: 3,
  QB: 4
}

const SOFT_RISK_CONTROL_TYPE = {
  QB: "qb",
  MONTH: "unimonth",
  GAME: "save"
}

const USER_VIP_GRADE = {
  COMMON: 0,
  VIP: 1,
  SVIP: 2
}

const USER_VIP_GRADE_NAME = {
  0: "普通用户",
  1: "QQ会员",
  2: "超级会员"
}

// 任务模式配置
const TASK_TYPES = {
  SIGN: "sign",
  PAY: "pay",
  READ: "read",
  ACTIVE: "active",
  STARTUP: "startup",
  BIRTHDAY: "birthday",
  SCORE: "score"
}

// 广场物品类型（载体类型）,type类型说明文档如下
// https://iwiki.woa.com/pages/viewpage.action?pageId=342856978
const GOODS_TYPES = {
  MONTH: "month",
  COIN: "coin",
  NEWS: "news",
  RANK: "rank",
  MUSIC: "music",
  IMAGE_TEXT: "imagetext",
  VIDEO: "video",
  JIFEN: "jifenProducts",
  AMS: "ams"
}

// 具体内容类别：0-未知、1-图文、2-长视频、3-短视频、
// 4-电子书-QQ阅读、5-音频、6-直播；7-电子书-动漫；
const CONTENT_TYPES = {
  unknown: 0,
  imageText: 1,
  longVideo: 2,
  shortVideo: 3,
  comic: 4,
  music: 5,
  live: 6,
  redirect: 7,
  // 运营广告位，非推荐返回
  ads: 200,
  bannerCard: 201,
  listCard: 202,
  rankCard: 203,
  newGameCard: 204,
  giftCard: 205,
  singleCard: 206,
  collectCard: 207
}

const APP_NAME = {
  ks: "快手",
  ws: "微视"
}

const RATE_TYPE = {
  hero: "1",
  skin: "2",
  newGame: "3",
  default: "0"
}

const SCORE_FACTORES = {
  single: 1,
  double: 2
}

const STAR_REMARK = {
  0: "暂无",
  1: "很差",
  2: "较差",
  3: "还行",
  4: "不错",
  5: "很棒"
}

// 点赞类型
const LIKE_TYPES = {
  video: "3", // 广场视频
  news: "2", // 资讯
  goods: "1" // 英雄皮肤
}

// 团购活动是否发放到角色 teamProcUseZoneID
const TEAM_PROC_ZONEID = {
  account: 0, // 发放到角色
  zone: 1, // 发放到大区
  role: 2 // 发放到角色
}

const PRIVACY_TYPES = {
  agree: 1,
  disagree: 2
}

const ITEM_TYPES = {
  hero: "10",
  skin: "13"
}

// 点券物品类型
const GAMECOIN_PRODUCT_TYPE = {
  priceListProduct: 1,
  customPriceProduct: 2,
  gamecoinPlusProduct: 3
}

export {
  TEAM_PROC_ZONEID,
  ACCOUNT_TYPE,
  CHECK_ROLE_TYPE,
  BUSINESS_TYPE,
  SOFT_RISK_CONTROL_TYPE,
  USER_VIP_GRADE,
  USER_VIP_GRADE_NAME,
  PRODUCT_STATUS,
  TASK_TYPES,
  GOODS_TYPES,
  CONTENT_TYPES,
  APP_NAME,
  LIKE_TYPES,
  RATE_TYPE,
  STAR_REMARK,
  PRIVACY_TYPES,
  SCORE_FACTORES,
  ITEM_TYPES,
  GAMECOIN_PRODUCT_TYPE
}
